import { render, staticRenderFns } from "./SettingScheduleNotiPop.vue?vue&type=template&id=3d96a50a&scoped=true"
import script from "./SettingScheduleNotiPop.vue?vue&type=script&lang=js"
export * from "./SettingScheduleNotiPop.vue?vue&type=script&lang=js"
import style0 from "./SettingScheduleNotiPop.vue?vue&type=style&index=0&id=3d96a50a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d96a50a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d96a50a')) {
      api.createRecord('3d96a50a', component.options)
    } else {
      api.reload('3d96a50a', component.options)
    }
    module.hot.accept("./SettingScheduleNotiPop.vue?vue&type=template&id=3d96a50a&scoped=true", function () {
      api.rerender('3d96a50a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/schedule/popup/SettingScheduleNotiPop.vue"
export default component.exports